export default __webpack_public_path__ + "static/giddaa_logo-27ed0feb85f3da44f7cb98df853fd372.svg";